import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Project } from '../models/project';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProjectDataService {

  constructor(private http: HttpClient) { }
  getAllProjects = (): Observable<Project[]> => {
    return this.http.get<Project[]>(`${environment.api.baseUrl}/${environment.api.endpoints.project.projectList}`);
  }

}
